
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/_core/helper/auth.guard';
import { TelaDeLiberarComponent } from './tela-de-liberar.component';
import { TelaDeLiberacaoComponent } from './tela-de-liberacao/tela-de-liberacao.component';

const routes: Routes = [
  {
    path: '',
    component: TelaDeLiberarComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:TelaDeLiberacaoComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TelaDeLiberacaoRoutingModule { }
